import { User } from '../../model/models';
import { FormattedMessage, useIntl } from 'react-intl';
import SelectSearch, { fuzzySearch } from 'react-select-search';
import { ModelsService } from '../../services/ModelsService';
import { WP_Tag } from '../../model/tags/tags';

interface SearchableTagProps {
  user: User;
  options: Array<WP_Tag>;
  label: string;
  name: string;
  onChange: (name: string, tag: number | undefined) => void;
  value?: number | undefined;
  borderStyle?: string;
}

export const SearchableTag: React.FC<SearchableTagProps> = ({
  user,
  options,
  label,
  name,
  onChange,
  value,
  borderStyle,
}: SearchableTagProps) => {
  const intl = useIntl();

  const options2 = options.map((o) => ({
    id: o.id,
    value: ModelsService.getTranslationFromTerm(o, user.acf.locale),
  }));

  const filterOptions = (options) => {
    const results = fuzzySearch(options);
    return results;
  };

  const handleClick = (event) => {
    onChange(name, undefined);
  };

  const CUSTOM_CLASSNAME = {
    container: 'w-full',
    value: 'text-gray-500 italic text-sm',
    input:
      'w-full focus:ring-0 focus:ring-offset-0 focus:outline-none focus:p-3 bg-white text-gray-500 not-italic',
    select: 'focus:ring-0 focus:ring-offset-0',
    options: 'w-full text-gray-500 mt-2 border-t-2 border-gray py-3',
    row: '',
    option: 'w-full text-left p-1 border-primary',
    group: '',
    'group-header': '',
    'is-selected': '',
    'is-highlighted': '',
    'is-loading': '',
    'is-multiple': '',
    'has-focus': '',
  };

  return (
    <div
      className={
        'flex flex-row justify-between items-center w-full border p-6 py-5 border-primary bg-white cursor-text ' +
        borderStyle
      }
    >
      <div className="w-full flex flex-1 flex-col justify-start items-start">
        <label className="text-base font-medium text-black">
          <FormattedMessage id={label} />
        </label>
        <div className="w-full" onClick={handleClick}>
          <SelectSearch
            options={options2.map((o) => ({ name: o.value, value: o.id + '' }))}
            value={value + ''}
            search={true}
            filterOptions={filterOptions}
            placeholder={intl.formatMessage({ id: label + ' Placeholder' })}
            className={(key) => {
              return CUSTOM_CLASSNAME[key];
            }}
            onChange={(selectedValue, selectedOption) => {
              if (selectedValue) {
                onChange(name, +selectedValue);
              }
            }}
          />
        </div>
      </div>
    </div>
  );
};
